// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-chrono-panel__backdrop {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12px 12px
    var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));
  background: rgba(8, 15, 28, 0.62);
  backdrop-filter: blur(4px);
  box-sizing: border-box;
}

.lt-chrono-panel {
  width: min(560px, 100%);
  max-width: 100%;
  max-height: min(
    calc(100dvh - var(--lt-coach-bar-reserve, 68px) - 24px - env(safe-area-inset-top)),
    820px
  );
  margin-top: max(8px, env(safe-area-inset-top));
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  border-radius: 16px;
  background: linear-gradient(165deg, #0f172a 0%, #1e293b 55%, #0b1220 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.45);
  color: #f8fafc;
  box-sizing: border-box;
}

.lt-chrono-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex: 0 0 auto;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.lt-chrono-panel__header-text {
  flex: 1 1 auto;
  min-width: 0;
}

.lt-chrono-panel__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.lt-chrono-panel__body {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.lt-chrono-panel__btn--add-players {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
  color: var(--lt-brand, #0877bc);
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
  white-space: nowrap;
}

.lt-chrono-panel__btn--add-players:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
}

.lt-chrono-panel__btn--save {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 78%, #0f172a);
}

.lt-chrono-panel__btn--review {
  background: rgba(56, 189, 248, 0.22);
  border-color: rgba(56, 189, 248, 0.45);
}

.lt-chrono-panel__btn--link-cam {
  background: rgba(255, 255, 255, 0.08);
}

.lt-chrono-panel__btn--link-cam-active {
  background: rgba(74, 222, 128, 0.22);
  border-color: rgba(74, 222, 128, 0.5);
}

.lt-chrono-panel__camera-bind {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 6px;
  padding: 0 14px 6px;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.lt-chrono-panel__camera-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 180px;
  font-size: 0.72rem;
  color: rgba(248, 250, 252, 0.72);
}

.lt-chrono-panel__camera-select {
  appearance: none;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(15, 23, 42, 0.85);
  color: #f8fafc;
  padding: 8px 10px;
  font-size: 0.82rem;
}

.lt-chrono-panel__section-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lt-chrono-panel__camera-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 168px;
  overflow: auto;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(15, 23, 42, 0.85);
}

.lt-chrono-panel__camera-option {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 0.82rem;
  line-height: 1.3;
  color: #f8fafc;
  cursor: pointer;
}

.lt-chrono-panel__camera-option input {
  flex: 0 0 auto;
  accent-color: var(--lt-brand, #0877bc);
}

.lt-chrono-panel__camera-option--all {
  font-weight: 650;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px 6px 0 0;
}

.lt-chrono-panel__camera-empty {
  margin: 6px 8px;
  font-size: 0.78rem;
  color: rgba(248, 250, 252, 0.62);
}

.lt-chrono-panel__info {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  vertical-align: middle;
}

.lt-chrono-panel__info-btn {
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
}

.lt-chrono-panel__info-btn[aria-expanded="true"] {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 72%, #0f172a);
  border-color: transparent;
}

.lt-chrono-panel__info-pop {
  position: absolute;
  z-index: 6;
  top: calc(100% + 6px);
  left: 0;
  width: min(280px, 72vw);
  padding: 8px 10px;
  border-radius: 10px;
  background: #0b1220;
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0;
  text-transform: none;
  color: rgba(248, 250, 252, 0.9);
}

.lt-chrono-panel__empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 14px 16px;
}

.lt-chrono-panel__eyebrow {
  margin: 0 0 4px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--lt-brand, #0877bc);
}

.lt-chrono-panel__header h2 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1.05rem;
  line-height: 1.2;
  min-width: 0;
}

.lt-chrono-panel__header h2 .MuiSvgIcon-root {
  flex-shrink: 0;
}

.lt-chrono-panel__subtitle {
  margin: 4px 0 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: rgba(248, 250, 252, 0.72);
}

.lt-chrono-panel__close {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lt-chrono-panel__error {
  margin: 8px 14px 0;
  color: #fecaca;
  font-size: 0.82rem;
}

.lt-chrono-panel__hint,
.lt-chrono-panel__empty {
  margin: 12px 14px;
  color: rgba(248, 250, 252, 0.7);
  font-size: 0.85rem;
}

.lt-chrono-panel__list {
  list-style: none;
  margin: 0;
  padding: 8px 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lt-chrono-panel__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas:
    "identity clock"
    "actions actions";
  gap: 4px 10px;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.lt-chrono-panel__row--running {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);
}

.lt-chrono-panel__row--rec {
  border-color: rgba(239, 68, 68, 0.75);
  box-shadow: inset 0 0 0 1px rgba(239, 68, 68, 0.35);
  background: color-mix(in srgb, #ef4444 12%, transparent);
}

.lt-chrono-panel__rec {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: 8px;
  padding: 1px 7px 1px 5px;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  vertical-align: middle;
  color: #fff;
  background: #dc2626;
  animation: lt-chrono-rec-pulse 1.2s ease-in-out infinite;
}

.lt-chrono-panel__rec::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
}

@keyframes lt-chrono-rec-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

@media (prefers-reduced-motion: reduce) {
  .lt-chrono-panel__rec {
    animation: none;
  }
}

.lt-chrono-panel__identity {
  grid-area: identity;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.lt-chrono-panel__order {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
}

.lt-chrono-panel__name {
  display: flex;
  align-items: center;
  gap: 0;
  min-width: 0;
  font-weight: 700;
  font-size: 0.86rem;
  line-height: 1.2;
}

.lt-chrono-panel__name-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-chrono-panel__drill {
  margin-top: 2px;
  font-size: 0.68rem;
  font-style: italic;
  color: #fde68a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-chrono-panel__meta {
  margin-top: 1px;
  font-size: 0.68rem;
  line-height: 1.25;
  color: rgba(248, 250, 252, 0.58);
}

.lt-chrono-panel__clock {
  grid-area: clock;
  align-self: center;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #f8fafc;
}

.lt-chrono-panel__actions {
  grid-area: actions;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
  min-width: 0;
}

.lt-chrono-panel__btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border: none;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-chrono-panel__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-chrono-panel__btn--start {
  background: var(--lt-brand, #0877bc);
  color: #fff;
}

.lt-chrono-panel__btn--stop {
  background: #d32f2f;
  color: #fff;
}

.lt-chrono-panel__btn--reset {
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  padding: 5px 8px;
}

.lt-chrono-panel__btn--delete {
  background: rgba(211, 47, 47, 0.18);
  color: #fecaca;
  padding: 5px 8px;
}

.lt-chrono-panel__btn--video {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 85%, #0f172a);
  color: #fff;
}

.lt-chrono-panel__btn--video-stop {
  background: #b71c1c;
  color: #fff;
}

.lt-chrono-panel__video-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  padding: 8px 14px 0;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.lt-chrono-panel__video-help {
  margin: 4px 14px 0;
  font-size: 0.72rem;
  line-height: 1.3;
  color: rgba(248, 250, 252, 0.55);
}

.lt-chrono-panel__video-hint {
  font-size: 0.78rem;
  color: rgba(248, 250, 252, 0.65);
}

.lt-chrono-panel__video-hint--ok {
  color: #86efac;
}

.lt-chrono-panel__video-hint--err {
  color: #fecaca;
}

.lt-chrono-panel__summary {
  margin: 6px 14px 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(248, 250, 252, 0.75);
}

.lt-chrono-panel__row-error {
  grid-column: 1 / -1;
  margin: 0;
  font-size: 0.78rem;
  color: #fecaca;
}

.lt-chrono-panel__row-hint {
  grid-column: 1 / -1;
  margin: 0;
  font-size: 0.75rem;
  color: rgba(248, 250, 252, 0.55);
}

@media (min-width: 520px) {
  .lt-chrono-panel__row {
    grid-template-columns: minmax(0, 1fr) auto auto;
    grid-template-areas: "identity clock actions";
    align-items: center;
  }

  .lt-chrono-panel__actions {
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingCoachChronoPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB;yEACuE;EACvE,iCAAiC;EACjC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf;;;GAGC;EACD,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0EAA0E;EAC1E,2CAA2C;EAC3C,2CAA2C;EAC3C,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,kDAAkD;EAClD,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yEAAyE;EACzE,+BAA+B;EAC/B,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qEAAqE;EACrE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,OAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C;;qBAEmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;AAC3E;;AAEA;EACE,qCAAqC;EACrC,mDAAmD;EACnD,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,6EAA6E;EAC7E,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;EACrE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,+CAA+C;IAC/C,6CAA6C;IAC7C,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".lt-chrono-panel__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 12px 12px\n    var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));\n  background: rgba(8, 15, 28, 0.62);\n  backdrop-filter: blur(4px);\n  box-sizing: border-box;\n}\n\n.lt-chrono-panel {\n  width: min(560px, 100%);\n  max-width: 100%;\n  max-height: min(\n    calc(100dvh - var(--lt-coach-bar-reserve, 68px) - 24px - env(safe-area-inset-top)),\n    820px\n  );\n  margin-top: max(8px, env(safe-area-inset-top));\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n  border-radius: 16px;\n  background: linear-gradient(165deg, #0f172a 0%, #1e293b 55%, #0b1220 100%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.45);\n  color: #f8fafc;\n  box-sizing: border-box;\n}\n\n.lt-chrono-panel__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex: 0 0 auto;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.lt-chrono-panel__header-text {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.lt-chrono-panel__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.lt-chrono-panel__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lt-chrono-panel__btn--add-players {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n  color: var(--lt-brand, #0877bc);\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n  white-space: nowrap;\n}\n\n.lt-chrono-panel__btn--add-players:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n}\n\n.lt-chrono-panel__btn--save {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 78%, #0f172a);\n}\n\n.lt-chrono-panel__btn--review {\n  background: rgba(56, 189, 248, 0.22);\n  border-color: rgba(56, 189, 248, 0.45);\n}\n\n.lt-chrono-panel__btn--link-cam {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.lt-chrono-panel__btn--link-cam-active {\n  background: rgba(74, 222, 128, 0.22);\n  border-color: rgba(74, 222, 128, 0.5);\n}\n\n.lt-chrono-panel__camera-bind {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 6px;\n  padding: 0 14px 6px;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.lt-chrono-panel__camera-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1 1 180px;\n  font-size: 0.72rem;\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.lt-chrono-panel__camera-select {\n  appearance: none;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(15, 23, 42, 0.85);\n  color: #f8fafc;\n  padding: 8px 10px;\n  font-size: 0.82rem;\n}\n\n.lt-chrono-panel__section-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.lt-chrono-panel__camera-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-height: 168px;\n  overflow: auto;\n  padding: 4px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(15, 23, 42, 0.85);\n}\n\n.lt-chrono-panel__camera-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 6px 8px;\n  border-radius: 6px;\n  font-size: 0.82rem;\n  line-height: 1.3;\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.lt-chrono-panel__camera-option input {\n  flex: 0 0 auto;\n  accent-color: var(--lt-brand, #0877bc);\n}\n\n.lt-chrono-panel__camera-option--all {\n  font-weight: 650;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px 6px 0 0;\n}\n\n.lt-chrono-panel__camera-empty {\n  margin: 6px 8px;\n  font-size: 0.78rem;\n  color: rgba(248, 250, 252, 0.62);\n}\n\n.lt-chrono-panel__info {\n  position: relative;\n  display: inline-flex;\n  flex: 0 0 auto;\n  vertical-align: middle;\n}\n\n.lt-chrono-panel__info-btn {\n  width: 22px;\n  height: 22px;\n  margin: 0;\n  padding: 0;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.lt-chrono-panel__info-btn[aria-expanded=\"true\"] {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 72%, #0f172a);\n  border-color: transparent;\n}\n\n.lt-chrono-panel__info-pop {\n  position: absolute;\n  z-index: 6;\n  top: calc(100% + 6px);\n  left: 0;\n  width: min(280px, 72vw);\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: #0b1220;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: 0;\n  text-transform: none;\n  color: rgba(248, 250, 252, 0.9);\n}\n\n.lt-chrono-panel__empty-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 14px 16px;\n}\n\n.lt-chrono-panel__eyebrow {\n  margin: 0 0 4px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-chrono-panel__header h2 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 1.05rem;\n  line-height: 1.2;\n  min-width: 0;\n}\n\n.lt-chrono-panel__header h2 .MuiSvgIcon-root {\n  flex-shrink: 0;\n}\n\n.lt-chrono-panel__subtitle {\n  margin: 4px 0 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.lt-chrono-panel__close {\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-chrono-panel__error {\n  margin: 8px 14px 0;\n  color: #fecaca;\n  font-size: 0.82rem;\n}\n\n.lt-chrono-panel__hint,\n.lt-chrono-panel__empty {\n  margin: 12px 14px;\n  color: rgba(248, 250, 252, 0.7);\n  font-size: 0.85rem;\n}\n\n.lt-chrono-panel__list {\n  list-style: none;\n  margin: 0;\n  padding: 8px 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lt-chrono-panel__row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-areas:\n    \"identity clock\"\n    \"actions actions\";\n  gap: 4px 10px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.lt-chrono-panel__row--running {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);\n}\n\n.lt-chrono-panel__row--rec {\n  border-color: rgba(239, 68, 68, 0.75);\n  box-shadow: inset 0 0 0 1px rgba(239, 68, 68, 0.35);\n  background: color-mix(in srgb, #ef4444 12%, transparent);\n}\n\n.lt-chrono-panel__rec {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: 8px;\n  padding: 1px 7px 1px 5px;\n  border-radius: 999px;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  vertical-align: middle;\n  color: #fff;\n  background: #dc2626;\n  animation: lt-chrono-rec-pulse 1.2s ease-in-out infinite;\n}\n\n.lt-chrono-panel__rec::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #fff;\n}\n\n@keyframes lt-chrono-rec-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.55;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lt-chrono-panel__rec {\n    animation: none;\n  }\n}\n\n.lt-chrono-panel__identity {\n  grid-area: identity;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lt-chrono-panel__order {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: 800;\n  background: rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n}\n\n.lt-chrono-panel__name {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  min-width: 0;\n  font-weight: 700;\n  font-size: 0.86rem;\n  line-height: 1.2;\n}\n\n.lt-chrono-panel__name-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-chrono-panel__drill {\n  margin-top: 2px;\n  font-size: 0.68rem;\n  font-style: italic;\n  color: #fde68a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-chrono-panel__meta {\n  margin-top: 1px;\n  font-size: 0.68rem;\n  line-height: 1.25;\n  color: rgba(248, 250, 252, 0.58);\n}\n\n.lt-chrono-panel__clock {\n  grid-area: clock;\n  align-self: center;\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #f8fafc;\n}\n\n.lt-chrono-panel__actions {\n  grid-area: actions;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.lt-chrono-panel__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  border: none;\n  border-radius: 999px;\n  padding: 5px 10px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-chrono-panel__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-chrono-panel__btn--start {\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n}\n\n.lt-chrono-panel__btn--stop {\n  background: #d32f2f;\n  color: #fff;\n}\n\n.lt-chrono-panel__btn--reset {\n  background: rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n  padding: 5px 8px;\n}\n\n.lt-chrono-panel__btn--delete {\n  background: rgba(211, 47, 47, 0.18);\n  color: #fecaca;\n  padding: 5px 8px;\n}\n\n.lt-chrono-panel__btn--video {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 85%, #0f172a);\n  color: #fff;\n}\n\n.lt-chrono-panel__btn--video-stop {\n  background: #b71c1c;\n  color: #fff;\n}\n\n.lt-chrono-panel__video-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 10px;\n  padding: 8px 14px 0;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.lt-chrono-panel__video-help {\n  margin: 4px 14px 0;\n  font-size: 0.72rem;\n  line-height: 1.3;\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.lt-chrono-panel__video-hint {\n  font-size: 0.78rem;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.lt-chrono-panel__video-hint--ok {\n  color: #86efac;\n}\n\n.lt-chrono-panel__video-hint--err {\n  color: #fecaca;\n}\n\n.lt-chrono-panel__summary {\n  margin: 6px 14px 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.75);\n}\n\n.lt-chrono-panel__row-error {\n  grid-column: 1 / -1;\n  margin: 0;\n  font-size: 0.78rem;\n  color: #fecaca;\n}\n\n.lt-chrono-panel__row-hint {\n  grid-column: 1 / -1;\n  margin: 0;\n  font-size: 0.75rem;\n  color: rgba(248, 250, 252, 0.55);\n}\n\n@media (min-width: 520px) {\n  .lt-chrono-panel__row {\n    grid-template-columns: minmax(0, 1fr) auto auto;\n    grid-template-areas: \"identity clock actions\";\n    align-items: center;\n  }\n\n  .lt-chrono-panel__actions {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
